import React, { useState, useEffect } from "react";
import { forwardRef } from "react";
import MaterialTable, { MTablePagination } from "material-table";
import { Button, Row, Col, Form } from "react-bootstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import { TablePagination } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";

import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Clear from "@mui/icons-material/Clear";
import FilterList from "@mui/icons-material/FilterList";
import FirstPage from "@mui/icons-material/FirstPage";
import LastPage from "@mui/icons-material/LastPage";
import Search from "@mui/icons-material/Search";
import ViewColumn from "@mui/icons-material/ViewColumn";
import CheckRole from "../CheckRole";
import AADService from "../funcionesAuth.js";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";
import * as XLSX from "xlsx";
import CircularProgress from "@mui/material/CircularProgress";

const tableIcons = {
  //Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function Valoracion() {
  const useStyles = makeStyles((theme) => ({
    container: {
      maxHeight: "55vh",
      minHeight: "55vh",
    },
    root: {
      width: "100%",
    },
    pagination: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    switch: {
      paddingLeft: "1.5em",
    },
    inside: {
      backgroundColor: "white",
      width: "100%",
      // margintom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: "#2c2a29",
      color: "white",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    palette: {
      primary: {
        main: "#4caf50",
      },
      secondary: {
        main: "#ff9100",
      },
    },
  }));

  var columns = [
    {
      field: "idefecto",
      title: "Id efecto",
    },
    {
      field: "tipoefecto",
      title: "Tipo Efecto",
    },
    {
      field: "nombreefecto",
      title: "Nombre Efecto",
    },
    {
      field: "resultado_p50",
      title: "Resultado p50",
    },
    {
      field: "resultado_p95",
      title: "Resultado p95",
    },
    {
      field: "resultado_p99",
      title: "Resultado p99",
    },
    {
      field: "metodovaloracion",
      title: "Metodo Valoracion",
    },
    {
      field: "analista",
      title: "Analista",
    },
  ];

  //Modifica temas predeterminados por Material-Table
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2c2a29",
      },
      secondary: {
        main: "#ff9100",
      },
    },
  });

  const classes = useStyles();
  const check = new CheckRole("/valoraciones");
  /*Se agrega el valor mediante serEfectolista*/
  const [efectoLista, setEfectoLista] = useState([]); //table data
  const [efectoFiltrado, setEfectoFiltrado] = useState([]); //table data

  const [impactolista, setImpactoLista] = useState([]); //table data
  const [frecuenciaLista, setFrecuenciaLista] = useState([]); //table data
  const [duracionLista, setDuracionLista] = useState([]); //table data
  const [rxEfectoOCLista, setRxEfectoOCLista] = useState([]); //table data

  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const [ButtonEdit, SetButtonEdit] = React.useState(false);
  const [selected, setSelected] = React.useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filter, setFilter] = useState(false);
  const [rutaEditar, setRutaEditar] = React.useState("editarAgregarEfectos");
  const [loading, setLoading] = React.useState(false);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();


  const definirRuta = async (ruta) => {
    setRutaEditar(ruta);
  };
  //Nos trae la información del back mediante un Json con un metodo de get
  useEffect(() => {
    /*se llama metodo para llamar la API*/
    const fetchdata = async () => {
      setLoading(true);
      const result = await fetch(
        /*URL base*/
        process.env.REACT_APP_API_URL +
          "efectoslista/descarga/0/" +
          localStorage.getItem("idcompania"),
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status >= 200 && result.status <= 300) {
        let data = await result.json();
        console.log(data);
        /*datos que me devolvio la API y se agrego a efectolista*/
        setEfectoLista(data['efectos']);
        setImpactoLista(data['impactos']);
        setFrecuenciaLista(data['frecuencias']);
        setDuracionLista(data['duraciones']);
        setRxEfectoOCLista(data['rxEfectoOC']);
        setLoading(false);
      } else if (result.status >= 400 && result.status <= 500) {
        return result.status;
      }
    };
    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "usuarios/menu/" +
          localStorage.getItem("usuario") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = [];
      let permisos = [];
      for (let i = 0; i < usuario.length; i++) {
        permisos = usuario[i].permisos.split(";");
        opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
      }
      setOpcionesGenerales(opciones);
      var validity = check.checkPermits(opciones, "GET");
      if (validity) {
      }
    };
    const fetchdatafiltrada = async() =>{
      const result_filtrado = await fetch(
        /*URL base*/
        process.env.REACT_APP_API_URL +
          "efectoslista/0/" +
          localStorage.getItem("idcompania"),
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result_filtrado.status >= 200 && result_filtrado.status <= 300) {
        let data_filtrado = await result_filtrado.json();
        console.log(data_filtrado);
        /*datos que me devolvio la API y se agrego a efectolista*/
        setEfectoFiltrado(data_filtrado);
      }
    };
    fetchdatafiltrada();
    fetchdata();
    fetchUsuario();
  }, []);

  function ExportarExcel(data_valoracion, data_impacto, data_frecuencia, data_duracion, data_rxEfectoOC) {
    // Crear un nuevo libro de trabajo
    const newBook = XLSX.utils.book_new();

    data_valoracion.forEach(function (json) {
      delete json.tableData;
    });
    // Convertir los datos JSON a una hoja de Excel
    const sheet1 = XLSX.utils.json_to_sheet(data_valoracion);
    const sheet2 = XLSX.utils.json_to_sheet(data_impacto);
    const sheet3 = XLSX.utils.json_to_sheet(data_frecuencia);
    const sheet4 = XLSX.utils.json_to_sheet(data_duracion);
    //const sheet5 = XLSX.utils.json_to_sheet(data_rxEfectoOC);

    // Agregar la hoja al libro de trabajo
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10); // AAAA-MM-DD
    XLSX.utils.book_append_sheet(newBook, sheet1, "Efectos_" + formattedDate);
    XLSX.utils.book_append_sheet(newBook, sheet2, "Impactos");
    XLSX.utils.book_append_sheet(newBook, sheet3, "Frecuencias");
    XLSX.utils.book_append_sheet(newBook, sheet4, "Duraciones");
    //XLSX.utils.book_append_sheet(newBook, sheet5, "RxEfectoOC");

    // Guardar el archivo con un nombre generado dinámicamente
    const fileName = "Valoraciones" + ".xlsx";
    XLSX.writeFile(newBook, fileName);
  }

  const handleClick = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], id);
      SetButtonEdit(true);
    } else {
      SetButtonEdit(false);
    }
    setSelected(newSelected);
  };
  const handleChange = () => {
    setFilter(!filter);
  };
  function add_eval() {
    localStorage.setItem("idimplementador", 0);
  }
  const editar = () => {
    console.log(selected);
    localStorage.setItem("idEfecto", selected);
  };

  return (
    <div className={classes.root}>
      <Row>
        <Col>
          <h2 className="titulo">Valoraciones</h2>
        </Col>
      </Row>

      <Paper variant="outlined" className={classes.paper}>
        <MuiThemeProvider theme={theme}>
          <MaterialTable
            columns={columns}
            data={efectoFiltrado}
            icons={tableIcons}
            options={{
              rowStyle: (rowData) => ({
                backgroundColor:
                  ButtonEdit === true && selectedRow === rowData.tableData.id
                    ? "#ffdb94"
                    : "#FFF",
              }),
              showTitle: false,
              filtering: filter,
              searchFieldAlignment: "left",
              searchFieldStyle: { height: 50 },
              headerStyle: {
                backgroundColor: "#2c2a29",
                color: "#ffffff",
                position: "sticky",
                top: 0,
                fontFamily: "CIBFont Sans Regular",
                fontWeight: 400,
                fontSize: "1.2rem",
                lineHeight: 1.6,
                letterSpacing: "0.0075em",
                flex: "1 1 100%",
              },
              maxBodyHeight: "650px",
              selection: false,
              disableMultipleSelection: true,
              pageSizeOptions: [10, 20, 30],
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 10,
            }}
            components={{
              Pagination: (props) => (
                <div className={classes.pagination}>
                  <FormControlLabel
                    className={classes.switch}
                    control={
                      <Checkbox
                        checked={filter}
                        onChange={handleChange}
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Mostrar filtros por columnas
                      </Typography>
                    }
                  />
                  <TablePagination {...props} className={classes.pagination} />
                </div>
              ),
            }}
            onRowClick={(evt, selectedRow) => {
              if (selectedRow.metodovaloracion === "Mezcla independientes") {
                definirRuta("editarAgregarEfectos");
              } else {
                definirRuta("EditarEfecto");
              }
              handleClick(selectedRow.idefecto);
              return setSelectedRow(selectedRow.tableData.id);
            }}
            actions={[
              loading
                ? {
                    icon: () => <CircularProgress />,
                    position: "toolbar",
                    isFreeAction: true,
                  }
                : {
                    icon: () => (
                      <Button className="botonPositivo">
                        Descargar Valoraciones
                      </Button>
                    ),
                    onClick: () => ExportarExcel(efectoLista, impactolista, frecuenciaLista, duracionLista, rxEfectoOCLista),
                    position: "toolbar",
                    isFreeAction: true,
                  }, 
                  {
                    icon: () => (
                      <Link to="crearEfecto">
                        {check.checkPermits(opcionesGenerales, "POST") ? (
                          <Button className="botonPositivo">
                            Crear efecto
                          </Button>
                        ) : (
                          ""
                        )}
                      </Link>
                    ),
                    onClick: add_eval,
                    position: "toolbar",
                    isFreeAction: true,
                  },
                  {
                    icon: () => (
                      <Link to="agregarEfectos">
                        {check.checkPermits(opcionesGenerales, "POST") ? (
                          <Button className="botonPositivo">Agregar efecto</Button>
                        ) : (
                          ""
                        )}
                      </Link>
                    ),
                    onClick: add_eval,
                    position: "toolbar",
                    isFreeAction: true,
                  },
                  {
                    icon: () => (
                      <Link to={rutaEditar}>
                        {check.checkPermits(opcionesGenerales, "PUT") ? (
                          <Button className="botonGeneral">Editar efecto</Button>
                        ) : (
                          ""
                        )}
                      </Link>
                    ),
                    onClick: editar,
                    position: "toolbar",
                    isFreeAction: true,
                    hidden: ButtonEdit === false,
                  },
            ]}
            localization={{
              toolbar: {
                searchPlaceholder: "Buscar",
              },
              body: {
                emptyDataSourceMessage: "No se encontraron registros",
              },
              pagination: {
                labelRowsSelect: "Filas",
                firstTooltip: "Primera página",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Última página",
              },
            }}
          />
        </MuiThemeProvider>
      </Paper>
    </div>
  );
}
export default Valoracion;
